import { isRecord } from './isRecord';

export interface IUnwrappedList {
  items: unknown[];
  total: number | null;
}

/**
 * Достаёт массив записей из ответа списка, форма конверта которого бэком не
 * подтверждена.
 *
 * Поддержаны три формы: массив в корне, `{ response: [...] }` и общий для
 * проекта `{ response: { items, meta: { total } } }`. Всё остальное считается
 * пустым списком — разбор не должен ронять экран.
 *
 * @param payload - тело ответа
 * @returns записи в сыром виде и общее количество, если оно пришло
 */
export const unwrapListPayload = (payload: unknown): IUnwrappedList => {
  if (Array.isArray(payload)) return { items: payload, total: null };

  if (!isRecord(payload)) return { items: [], total: null };

  const { response } = payload;

  if (Array.isArray(response)) return { items: response, total: null };

  if (isRecord(response)) {
    const total =
      isRecord(response.meta) && typeof response.meta.total === 'number'
        ? response.meta.total
        : null;
    return {
      items: Array.isArray(response.items) ? response.items : [],
      total
    };
  }

  return { items: [], total: null };
};
